@if (activePolicy()) {
  <h2
    mat-dialog-title
    class="title">
    {{ activePolicy()?.title }}
  </h2>
  <mat-dialog-content
    class="content"
    [innerHTML]="activePolicy()?.contentHtml">
  </mat-dialog-content>

  @if (errorMessage()) {
    <div class="error-banner">{{ errorMessage() }}</div>
  }

  <div
    mat-dialog-actions
    class="actions">
    @if (!isReadOnly()) {
      <mat-checkbox
        class="consent-checkbox"
        [checked]="accepted()"
        (change)="accepted.set($event.checked)">
        <span class="policy-bold">I have read and agree to Tapestry's Privacy Policy.</span>
      </mat-checkbox>
    }

    <div
      class="button-row"
      [class.readonly-row]="isReadOnly()">
      <button
        matButton="filled"
        class="close-button"
        [disabled]="submitting()"
        (click)="onClose()">
        Close
      </button>

      @if (!isReadOnly()) {
        <div class="submit-wrapper">
          @if (submitting()) {
            <mat-progress-spinner
              mode="indeterminate"
              diameter="20"></mat-progress-spinner>
          }
          <button
            matButton="filled"
            class="accept-button"
            [disabled]="!accepted() || submitting()"
            (click)="onAccept()">
            Accept
          </button>
        </div>
      }
    </div>
  </div>
} @else if (isLoadFailed()) {
  <div class="error-state">
    <p>Failed to load the active legal agreements.</p>
    <p>Please reload the page or contact support.</p>
  </div>
} @else {
  <div
    class="loading-state"
    role="status"
    aria-live="polite">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="48"
      aria-label="Loading legal agreements"></mat-progress-spinner>
    <p>Loading legal agreements...</p>
  </div>
}
